/*
 * Copyright (c) 2019 Honeywell International, Inc. All rights reserved.
 *
 * This file contains trade secrets of Honeywell International, Inc.  No part
 *  may be reproduced or transmitted in any form by any means or for any
 *  purpose without the express written permission of Honeywell.
 *
 */

import React from 'react';
import { ISiteDetails } from "../stores/GatewayManager/IGatewayRegistrationInterfaces";

/**
 * Constants for the site-gateway registration app
 */
export default class DIYAppConstants {
  public static readonly API_CUSTOMER_LIST = '/api/organizationservice/organizations/details';
  public static readonly API_ALL_SITE_LIST = '/api/CloudConnectorReg/Organizations?SystemDetails=false';
  public static readonly API_SITE_LIST = (orgId: string) => `/api/Organization?GetEulaDocumentTypes=false&CustomerId=${orgId}`;
  public static readonly API_SITE_FOR_USER_AUTH_GROUP = '/api/User/AuthGroup';
  public static readonly SITE_ADDRESS_PLACEHOLDER = ' - ';
  public static readonly GATEWAY_LIST_BY_SITE_ID = '/api/gateways/site/';
  public static readonly GATEWAY_LIST_BY_SITE_ID_AZURE= '/projects/fchttp-test-inc-qa/site/';
  public static readonly DEVICE_URL = (redirect_uri: string, domain: string, forge_route: string) => `${redirect_uri}/#/domains/${domain}?forge_route=${forge_route}`;
  public static readonly EPM_ROUTE = '/fcp/register/main';
  public static readonly NON_EPM_ROUTE = '/ap/register';

  public static readonly SC_API_UPLOAD_CSR = '/iam/bootstrapClient';
  public static readonly SC_API_GET_CLIENT = (clientId: string) => `/iam/client/${clientId}`;

  public static readonly SUCCESS_COLOR = '#7eb338';
  public static readonly IMPORTANT_COLOR = '#f5a623';
  public static readonly ERROR_COLOR = '#ff0000';
  public static readonly WARNING_COLOR = '#f5a623';
  public static readonly DEFAULT_COLOR = '#f5a623';

  public static readonly CONTACT_SUPPORT_COLOR = 'rgb(208, 208, 208)';
  public static readonly PROVIDER_NAME_AZURE = 'azure';

  public static readonly HONEYWELL_CERTIFIED = 'HONEYWELL CERTIFIED';

  //Stores
  public static readonly GATEWAY_IDENTITY_STORE = 'gatewayIdentityStore';

  public static readonly SITE_DETAILS_BLOCK = (site: ISiteDetails): JSX.Element => {
    return <div key={1} className='ui-reg-summary-site-details'>
      <div className='ui-reg-addr-name'>
        {site.siteName}
      </div>
      <div className='ui-reg-addr-loc'>
        {site.address1 || site.customerDetails.address1 || DIYAppConstants.SITE_ADDRESS_PLACEHOLDER}
      </div>
      <div className='ui-reg-addr-loc'>
        {site.address2 || site.customerDetails.address2 || DIYAppConstants.SITE_ADDRESS_PLACEHOLDER}
      </div>
    </div>
  }
}
